let promiseParams = '';

export const fetchData = (
  promise: Promise<any> | undefined,
  currentParams: string
): Promise<unknown> | null => {
  if (!promise) return null;
  promiseParams = currentParams;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      (result) => {
        if (promiseParams === currentParams) {
          resolve(result);
        } else {
          reject(new Error('Promise was canceled'));
        }
      },
      (error) => {
        if (promiseParams === currentParams) {
          reject(error);
        } else {
          reject(new Error('Promise was canceled'));
        }
      }
    );
  });

  return wrappedPromise;
};
